import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { AuthUser } from '../../../models/auth.models';

@Component({
  selector: 'app-unauthorized',
  template: `
    <div class="container-fluid h-100 d-flex align-items-center justify-content-center">
      <div class="text-center">
        <div class="error-code">403</div>
        <h1>Access Denied</h1>
        <p class="lead">You don't have permission to access this resource.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
        
        <div class="mt-4">
          <button class="btn btn-primary me-2" (click)="goBack()">
            <i class="fas fa-arrow-left"></i> Go Back
          </button>
          <button class="btn btn-outline-secondary me-2" (click)="goToDashboard()">
            <i class="fas fa-home"></i> Dashboard
          </button>
          <button class="btn btn-outline-danger" (click)="logout()">
            <i class="fas fa-sign-out-alt"></i> Logout
          </button>
        </div>

        <div class="mt-4" *ngIf="currentUser">
          <small class="text-muted">
            Logged in as: {{ currentUser!.name }} ({{ currentUser!.roles.join(', ') }})
          </small>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .error-code {
      font-size: 8rem;
      font-weight: bold;
      color: #dc3545;
      line-height: 1;
    }
    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
    }
    .container-fluid {
      min-height: 100vh;
    }
  `]
})
export class UnauthorizedComponent implements OnInit {
  currentUser: AuthUser | null = null;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserValue();
  }

  goBack(): void {
    window.history.back();
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }
}
